import { sleep } from '@/util'

export default {
  name: 'ui',
  namespaced: true,
  state: {
    captureMode: false,
    showErrorMode: false, // 펀다나우 계약서 작성시 미비된 부분 에러ui 표출 여부

    footer: false,
  },
  mutations: {
    setCaptureMode(state, flag) {
      state.captureMode = flag
    },
    setShowErrorMode(state, flag) {
      state.showErrorMode = flag
    },
    setFooter(state, flag) {
      state.footer = flag
    },
  },
  actions: {
    async activateErrorMode({ state, commit }) {
      if (state.showErrorMode) return

      // 5초동안 표시?
      commit('setShowErrorMode', true)
      await sleep(5000)
      commit('setShowErrorMode', false)
    },
  },
}
